export function initTransitions($) {
    $(".gb-grid-wrapper").each(function (n, wrap) {
        var kids = $("> .gb-grid-column", wrap).length;

        if (kids != 2) {
            $("> .gb-grid-column", wrap).each(function (n, item) {
                $(item)
                    .attr("data-aos", "fade-up")
                    .attr("data-aos-delay", 300 * n);
            });
        } else {
			$("> .gb-grid-column:nth-child(1)", wrap).attr("data-aos", "fade-right")
			$("> .gb-grid-column:nth-child(2)", wrap)
				.attr("data-aos", "fade-left")
				.attr("data-aos-delay", 400);
		}
    });

    $(".section-title").each(function (n, wrap) {
        $(wrap).attr("data-aos", "fade-up");
    });

    $(".carousel3d").each(function (n, wrap) {
        $(wrap).attr("data-aos", "zoom-in");
    });

    $(".news-listing-grid").each(function (n, wrap) {
        $(wrap).attr("data-aos", "fade-up");
    });

    $(".event-slider").each(function (n, wrap) {
        $(".event-card", wrap).each(function (n, item) {
            $(item)
                .attr("data-aos", "fade-up")
                .attr("data-aos-delay", 400 * n);
        });
    });

    $(".wp-block-cover").each(function (n, wrap) {
        $("> .wp-block-cover__inner-container", wrap).each(function (n, item) {
            $(item).attr("data-aos", "fade-left");
        });
    });

    $(".wp-block-pullquote, .wp-block-quote").each(function (n, wrap) {
        $(wrap).attr("data-aos", "fade-up");
    });

    $(".wp-block-embed, .wp-block-table").each(function (n, wrap) {
        $(wrap).attr("data-aos", "fade-up");
    });

    $(".site-footer-cta-buttons").each(function (n, wrap) {
        $(".site-footer-cta-button", wrap).each(function (n, item) {
            $(item)
                .attr("data-aos", "flip-left")
                .attr("data-aos-delay", 400 * n);
        });
    });
}
